<template>
  <md-dialog
      class="maintenance-dialog"
      :closable="false"
      v-model="value"
  >
    <div class="main">
      <div class="title">{{ $t('maintenanceTitle') }}</div>
      <div class="content">{{ sysMaintenanceInfo.msg }}</div>
      <div class="time">{{ $t('maintenanceTime') }}：{{`${ sysMaintenanceInfo.start } - ${ sysMaintenanceInfo.end }`}}</div>
    </div>
  </md-dialog>
</template>

<script>
import { Dialog } from 'mand-mobile';

export default {
  name: 'sysMaintenance',
  components: {
    [Dialog.name]: Dialog
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('publicStore', ['sysMaintenanceInfo'])
  }
};
</script>

<style lang="scss">
.maintenance-dialog {
  .md-dialog-content {
    width: 254px!important;
    min-height: 372px;
    background-color: transparent;
    background-image: url("./assets/bg.png");
    background-size: contain;
    overflow: unset;

    .md-dialog-body {
      padding: 226px 0 0;

      .main {
        min-height: 141px;
        padding-bottom: 40px;
        background-color: #FFF;
        font-family: 'PingFang SC';
        border-radius: 14px;

        .title {
          margin-bottom: 12px;
          font-weight: 500;
          font-size: 16px;
          line-height: 16px;
          text-align: center;
          color: #544431;
        }

        .content {
          padding: 0 30px;
          margin-bottom: 18px;
          font-weight: 400;
          font-size: 13px;
          line-height: 20px;
          text-align: center;
          color: #544431;
          word-break: break-word;
        }

        .time {
          padding: 0 14px;
          font-weight: 500;
          font-size: 13px;
          line-height: 20px;
          text-align: center;
          color: #32B8AF;
        }
      }
    }

    .md-dialog-actions {
      display: none;
    }
  }
}
</style>
